import { PAddStdButton } from "./PAddStdButton";

export function AddStdButton(panel, xPos, yPos, width, height, label, cmdCode) {
  var stdButton = PAddStdButton(panel, xPos, yPos, width, height, label, cmdCode, false);
  return stdButton;
}
